import { createSlice } from "@reduxjs/toolkit";

export const branchSettingsSliceNew = createSlice({
  name: "branchSettingsSliceNew",
  initialState: {
    apiResList: undefined,
    rowData:undefined,
    branchPosConfigurations:null,
    externalTocken:null

  },
  reducers: {
    get_branch_settings_list: (state, action) => {
      state.apiResList = action.payload.branchSettingsData;
    },
    get_branch_settings_row_data_list: (state, action) => {
      state.rowData = action.payload.branchSettingsSingleData;
    },
    setBranchPosConfigurations: (state, action) => {
      state.branchPosConfigurations = action.payload;
    },
    setExternalTocken: (state, action) => {
      state.externalTocken = action.payload;
    }

  },
});

export const { get_branch_settings_list,get_branch_settings_row_data_list,setBranchPosConfigurations,setExternalTocken} = branchSettingsSliceNew.actions;

export default branchSettingsSliceNew.reducer;
